$shm_ba_agent_message_text $shm_agent_message_text
	Posts* $shm_ba_agent_message_posts
		table <= posts_table* null
	Posts_invalid* $mol_view
		sub <= posts_invalid_rows* /
	Posts_error* $mol_view
		sub / <= posts_error* \
